import React from 'react';
import TextBase from './TextBase';
import { TText } from './types';

const Micro = ({ as = 'span', color = '', ...rest }: TText) => (
  <TextBase {...rest} as={as} kind="body-micro" color={color} />
);

export default Micro;
